import '../text';
import { defineCustomElement, getBooleanAttribute, getAttribute, updateBooleanAttribute, updateAttribute, NectaryElement, isAttrTrue, isAttrEqual } from '../utils';
const templateHTML = '<style>:host{display:inline-block;vertical-align:middle;outline:0}#wrapper{display:flex;flex-direction:row;align-items:center;gap:4px;width:100%;height:var(--sinch-comp-tag-size-container-m);padding:0 9px;border-radius:var(--sinch-comp-tag-shape-radius);background-color:var(--sinch-comp-tag-color-default-background);box-sizing:border-box;user-select:none;--sinch-global-color-text:var(--sinch-comp-tag-color-default-foreground);--sinch-global-color-icon:var(--sinch-comp-tag-color-default-foreground);--sinch-global-size-icon:var(--sinch-comp-tag-size-icon-m)}:host([small]) #wrapper{height:var(--sinch-comp-tag-size-container-s);padding:0 8px;--sinch-global-size-icon:var(--sinch-comp-tag-size-icon-s)}#text{flex:1;--sinch-comp-text-font:var(--sinch-comp-tag-font-size-m-label)}:host([small]) #text{--sinch-comp-text-font:var(--sinch-comp-tag-font-size-s-label)}::slotted(*){margin-left:-4px}</style><div id="wrapper"><slot name="icon"></slot><sinch-text id="text" type="s" ellipsis></sinch-text></div>';
import { getTagColorBg, getTagColorFg } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-tag', class extends NectaryElement {
  #$text;
  #$wrapper;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$wrapper = shadowRoot.querySelector('#wrapper');
    this.#$text = shadowRoot.querySelector('#text');
  }
  connectedCallback() {
    super.connectedCallback();
    this.#updateColor();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  get color() {
    return getAttribute(this, 'color');
  }
  set color(value) {
    updateAttribute(this, 'color', value);
  }
  get text() {
    return getAttribute(this, 'text', '');
  }
  set text(value) {
    updateAttribute(this, 'text', value);
  }
  get small() {
    return getBooleanAttribute(this, 'small');
  }
  set small(isSmall) {
    updateBooleanAttribute(this, 'small', isSmall);
  }
  static get observedAttributes() {
    return ['text', 'color', 'small'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    if (isAttrEqual(oldVal, newVal)) {
      return;
    }
    switch (name) {
      case 'color':
        {
          this.#updateColor();
          break;
        }
      case 'text':
        {
          this.#$text.textContent = newVal;
          break;
        }
      case 'small':
        {
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
    }
  }
  #updateColor() {
    if (!this.isDomConnected) {
      return;
    }
    const colorName = this.color;
    if (colorName !== null && colorName.length > 0) {
      const bg = getTagColorBg(colorName);
      const fg = getTagColorFg(colorName);
      this.#$wrapper.style.setProperty('background-color', bg);
      this.#$wrapper.style.setProperty('--sinch-global-color-text', fg);
      this.#$wrapper.style.setProperty('--sinch-global-color-icon', fg);
    } else {
      this.#$wrapper.style.removeProperty('background-color');
      this.#$wrapper.style.removeProperty('--sinch-global-color-text');
      this.#$wrapper.style.removeProperty('--sinch-global-color-icon');
    }
  }
});